import type { UserId } from "@core/domains/identity";

import { useZodForm } from "@react/foundation/react-hook-form";

import { billingAdminApi } from "@apis/billing/api";

import { useBillingActions } from "./useBillingActions.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useTopUpForm({
  onSuccess,
  principalId,
}: {
  readonly onSuccess: () => void;
  readonly principalId: UserId;
}) {
  const { topUp } = useBillingActions();
  const form = useZodForm({
    defaultValues: { amount: "", description: "" },
    errorMapping: {
      amount: {
        invalid: "Enter a valid dollar amount",
        required: "Amount is required",
      },
    },
    onSubmit: async values => {
      await topUp.mutateAsync(
        { ...values, principalId },
        {
          onSuccess: () => {
            onSuccess();
            form.reset();
          },
        },
      );
    },
    schema: billingAdminApi.endpoints.topUp.body.pick({
      amount: true,
      description: true,
    }),
    transform: values => {
      return {
        amount: values.amount || undefined,
        description: values.description || undefined,
      };
    },
  });

  return form;
}
